const TAG = {
  FINAL_SALE: "Final Sale",
  MYSTERY: "mystery",
};

export default TAG;
